export {
  VIRGIN_HORIZON,
  VIRGIN_TIVO,
  STANDALONE_PLAYER_BASE_URL,
  ENVIRONMENT
} from './constants'
